import { render, staticRenderFns } from "./ClaimGeneralDetails.vue?vue&type=template&id=5eb41cb8&"
import script from "./ClaimGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimGeneralDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports